

export const cost_per_km2_wind = 0.006
export const cost_per_km2_solar = 0.010
export const cost_per_nuclear_plant = 4
